//服务网点
export default [
    {
        alias: '',
        path: 'serviceMgt',
        name: 'serviceMgt',
        meta: {
            title: '售后管理',
            icon: 'serviceMgt'
        },
        hidden: false,
        component: () => import("@/views/afterSales/serviceMgt/index.vue"),
        children: [{
            alias: '',
            path: 'stationList',
            name: 'stationList',
            meta: {
                title: '网点列表',
                icon: 'stationList'
            },
            hidden: false,
            component: () => import("@/views/afterSales/serviceMgt/stationList.vue"),
        }]
    }

]